import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { fetchProducts, fetchCategories } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import ProductCard from "@/components/ProductCard";

const cleanCat = (t) => t.split("Manufacturer")[0].split("Hand Tool")[0].trim() || t;

const ProductsList = () => {
  const [params, setParams] = useSearchParams();
  const cat = params.get("category") || "";
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchCategories().then(setCats); }, []);

  useEffect(() => {
    setLoading(true);
    fetchProducts({ category: cat || undefined, q: q || undefined, limit: 500 }).then((r) => {
      setItems(r.items); setTotal(r.total); setLoading(false);
    });
  }, [cat, q]);

  return (
    <>
      <PageHero
        eyebrow="Catalogue"
        title={cat ? `${cleanCat(cats.find((c) => c.slug === cat)?.title || cat)}` : "All Products"}
        intro={cat ? "Browse this product family." : "All 100+ tools across all 22 categories."}
        breadcrumbs={<>Home / <span className="text-white">Products</span>{cat ? <> / <span className="text-white">{cleanCat(cats.find((c) => c.slug === cat)?.title || cat)}</span></> : null}</>}
      />
      <Section>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div className="eyebrow">{total} products</div>
          <div className="flex items-center gap-2 flex-wrap">
            <select
              value={cat}
              onChange={(e) => {
                const v = e.target.value;
                const next = new URLSearchParams(params);
                if (v) next.set("category", v); else next.delete("category");
                setParams(next);
              }}
              className="bg-white border border-[var(--jt-border)] px-3 py-2 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]"
              data-testid="filter-category"
            >
              <option value="">All categories</option>
              {cats.map((c) => <option key={c.slug} value={c.slug}>{cleanCat(c.title)} ({c.product_count})</option>)}
            </select>
            <input
              type="search"
              placeholder="Search tools..."
              defaultValue={q}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const v = e.currentTarget.value;
                  const next = new URLSearchParams(params);
                  if (v) next.set("q", v); else next.delete("q");
                  setParams(next);
                }
              }}
              className="bg-white border border-[var(--jt-border)] px-3 py-2 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]"
              data-testid="filter-search"
            />
          </div>
        </div>

        {loading ? (
          <div className="font-mono text-sm text-[var(--jt-text-muted)]">Loading...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-20">
            <div className="font-mono text-sm text-[var(--jt-text-muted)]">No products match.</div>
            <Link to="/products" className="mt-4 inline-flex jt-btn jt-btn-outline">Reset filters</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="products-grid">
            {items.map((p) => <ProductCard key={p.slug} p={p} />)}
          </div>
        )}
      </Section>
    </>
  );
};

export default ProductsList;
